export const EDITOR_SHOW  = 'EDITOR_SHOW';
export const EDITOR_HIDE  = 'EDITOR_HIDE';